import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { NoDocumentsNew, AddWhiteIcon } from "../../../assets/images";
import { MuiStack, MuiButton } from "../../../components";
var NoDocumnetFound = function (props) {
    var Img = styled("img")(function (_ref) {
        var theme = _ref.theme;
        return {};
    });
    var title = props.title, paragraph = props.paragraph, height = props.height, buttonNew = props.buttonNew, onButtonNewClick = props.onButtonNewClick;
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        height: height ? height : '100%',
        spacing: 2,
        padding: 2,
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Img, {
        id: "blankDocIcon",
        src: NoDocumentsNew,
        alt: "altimg"
    })), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        id: "blankDocTitle",
        variant: "h1",
        sx: {
            textAlign: 'center'
        }
    }, title)), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        id: "blankDocParagraph",
        variant: "h4",
        sx: {
            color: '#8593A3',
            textAlign: 'center'
        }
    }, paragraph)), buttonNew && /*#__PURE__*/ React.createElement(MuiStack, {
        id: "spareIssueButtonStack",
        alignContent: 'center'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        marginRight: 3
    }), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiButton, {
        size: "large",
        color: "primary",
        id: "spareIssueNewButton",
        onClick: onButtonNewClick,
        name: buttonNew,
        variant: "contained",
        startIcon: /*#__PURE__*/ React.createElement("img", {
            src: AddWhiteIcon,
            color: "#FFFFFF"
        })
    }))));
};
export default NoDocumnetFound;
